import React from 'react';
import { Watch, Smartphone } from 'lucide-react';
export function DeviceSupport() {
  return <section className="py-20 bg-white border-y border-slate-100" data-id="element-1">
      <div className="container mx-auto px-4" data-id="element-2">
        <div className="flex flex-col md:flex-row items-center justify-between gap-12 max-w-5xl mx-auto" data-id="element-3">
          <div className="flex-1 text-center md:text-left" data-id="element-4">
            <h2 className="text-3xl font-bold text-slate-900 mb-4" data-id="element-5">
              Works with your devices
            </h2>
            <p className="text-slate-600 mb-8" data-id="element-6">
              Vytaniq connects directly to Google Fit, meaning it works with
              almost any Android-compatible wearable.
            </p>

            <div className="flex flex-wrap gap-4 justify-center md:justify-start" data-id="element-7">
              <div className="flex items-center gap-2 px-4 py-2 bg-slate-50 rounded-lg border border-slate-200 text-slate-700 font-medium" data-id="element-8">
                <Smartphone className="h-4 w-4" data-id="element-9" /> Android
              </div>
              <div className="flex items-center gap-2 px-4 py-2 bg-slate-50 rounded-lg border border-slate-200 text-slate-700 font-medium" data-id="element-10">
                <Watch className="h-4 w-4" data-id="element-11" /> Fitbit
              </div>
              <div className="flex items-center gap-2 px-4 py-2 bg-slate-50 rounded-lg border border-slate-200 text-slate-700 font-medium" data-id="element-12">
                <Watch className="h-4 w-4" data-id="element-13" /> Samsung
              </div>
              <div className="flex items-center gap-2 px-4 py-2 bg-slate-50 rounded-lg border border-slate-200 text-slate-700 font-medium" data-id="element-14">
                <Watch className="h-4 w-4" data-id="element-15" /> Garmin
              </div>
            </div>
          </div>

          <div className="flex-1 bg-slate-50 p-8 rounded-2xl border border-slate-100 w-full max-w-md" data-id="element-16">
            <div className="flex items-center gap-4 mb-4 opacity-50" data-id="element-17">
              <div className="h-10 w-10 bg-slate-200 rounded-full flex items-center justify-center" data-id="element-18">
                <svg className="h-5 w-5 text-slate-500" viewBox="0 0 24 24" fill="currentColor" data-id="element-19">
                  <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.21-1.98 1.08-3.11-1.06.05-2.31.71-3.06 1.58-.69.8-1.27 2.09-1.1 3.07 1.17.09 2.36-.73 3.08-1.54z" data-id="element-20" />
                </svg>
              </div>
              <div data-id="element-21">
                <h3 className="font-semibold text-slate-900" data-id="element-22">Apple Health</h3>
                <p className="text-sm text-slate-500" data-id="element-23">Coming later</p>
              </div>
            </div>
            <p className="text-sm text-slate-500 bg-white p-3 rounded-lg border border-slate-200 inline-block" data-id="element-24">
              Are you an Apple user?{' '}
              <span className="text-teal-600 font-medium" data-id="element-25">
                Join the waitlist
              </span>{' '}
              to vote for iOS support.
            </p>
          </div>
        </div>
      </div>
    </section>;
}